var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import debounce from 'debounce';
import { equals } from 'ramda';
import { getViewport } from './util';
var ViewportContext = createContext(null);
var viewportContext = function () {
    var context = useContext(ViewportContext);
    if (!context) {
        throw new Error("useViewport must be used within a ViewportProvider");
    }
    return context;
};
var Provider = function (props) {
    var state = props.state, passThrough = __rest(props, ["state"]);
    var _a = useState(state ? state : getViewport()), viewport = _a[0], setViewport = _a[1];
    var value = React.useMemo(function () { return [viewport]; }, [viewport]);
    var debounceViewport = useRef(debounce(function (next) {
        setViewport(next);
    }, 300));
    useEffect(function () {
        var subscribe = debounceViewport.current;
        var onResize = function () {
            var vp = getViewport();
            if (!equals(vp, viewport)) {
                subscribe(vp);
            }
        };
        window.addEventListener('resize', onResize);
        return function () {
            subscribe.clear();
            window.removeEventListener('resize', onResize);
        };
    });
    return React.createElement(ViewportContext.Provider, __assign({ value: value }, passThrough));
};
Object.freeze(Provider);
Object.freeze(viewportContext);
export var ViewportProvider = Provider;
export var useViewport = viewportContext;
//# sourceMappingURL=viewport.js.map